<div class="main-container">
  <div class="overlay" *ngIf="opened"></div>
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToOpsVendorDashboard()">
      {{ ContractorListEnum.Breadcrumb }}
    </span>
  </div>
  <div class="contractor-list-container">
    <div class="contractor-search-table-container">
      <div class="contractor-list-search">
        <div class="contractor-title card-title-static">
          <span class="ct-badge"><i class="material-icons">groups</i></span>
          <span class="ct-text">{{ ContractorListEnum.ListOfContractors }} ({{ totalCount }})</span>
        </div>
        <div class="search-bar-container">
          <div class="search-child">
            <emerald-input
              [label]="'Search'"
              [trailingIcon]="'search'"
              (keyup)="searchContractors($event)"
              [value]="filterValue"
              [disabled]="!isDataLoaded"
              ><emerald-icon
                *ngIf="filterValue?.length"
                [icon]="'close'"
                (click)="clearInput()"
              ></emerald-icon>
            </emerald-input>
          </div>
          <div class="filter-child">
            <emerald-menu
              [opened]="opened"
              [position]="'bottom_end'"
              [targetElement]="navTemplate"
              [menuTemplate]="menuTemplate"
              (openChange)="opened = $event"
            ></emerald-menu>
            <ng-template #navTemplate>
              <emerald-button
                [label]="'Filter'"
                [size]="'Small'"
                [type]="'Secondary'"
                [icon]="'filter_list'"
                [iconPosition]="'Left'"
                [disabled]="!isDataLoaded"
                (onClick)="toggleFilter()"
              ></emerald-button>
            </ng-template>
            <ng-template #menuTemplate>
              <app-ops-contractors-list-filter
                [ContractorDataByFilter]="contractorsListView"
                (filterApplied)="onFilterApplied($event)"
                (filterReset)="onFilterReset($event)"
                (closeFilter)="closeFilter()"
              ></app-ops-contractors-list-filter>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="contractor-list-table">
        <ng-container
          *ngIf="isDataLoaded && displayData?.length; else noDataTemplate"
        >
          <div class="op-table-wrap">
            <table class="op-table cl-table">
              <thead>
                <tr>
                  <th class="sortable" (click)="sortBy('name')">Contractor Name <span class="op-sort" [class.asc]="sortField === 'name' && sortDir === 'asc'" [class.desc]="sortField === 'name' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('reportingManager')">Reporting Manager <span class="op-sort" [class.asc]="sortField === 'reportingManager' && sortDir === 'asc'" [class.desc]="sortField === 'reportingManager' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('status')">Status <span class="op-sort" [class.asc]="sortField === 'status' && sortDir === 'asc'" [class.desc]="sortField === 'status' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('sowExpiry')">SOW Expiry <span class="op-sort" [class.asc]="sortField === 'sowExpiry' && sortDir === 'asc'" [class.desc]="sortField === 'sowExpiry' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('doj')">DOJ <span class="op-sort" [class.asc]="sortField === 'doj' && sortDir === 'asc'" [class.desc]="sortField === 'doj' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('vendor')">Vendor <span class="op-sort" [class.asc]="sortField === 'vendor' && sortDir === 'asc'" [class.desc]="sortField === 'vendor' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('location')">Location <span class="op-sort" [class.asc]="sortField === 'location' && sortDir === 'asc'" [class.desc]="sortField === 'location' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('totalExp')">Total Exp. <span class="op-sort" [class.asc]="sortField === 'totalExp' && sortDir === 'asc'" [class.desc]="sortField === 'totalExp' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('rto')">RTO <span class="op-sort" [class.asc]="sortField === 'rto' && sortDir === 'asc'" [class.desc]="sortField === 'rto' && sortDir === 'desc'"></span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of pagedData">
                  <td>
                    <div class="contractor-info">
                      <div class="name">
                        <a (click)="navigateToContractorProfile(v)">{{ v.name }}</a>
                      </div>
                      <div class="job-title" [attr.title]="v.jobTitle || null">{{ v.jobTitle }}</div>
                    </div>
                  </td>
                  <td [attr.title]="v.reportingManager || null">{{ v.reportingManager || '—' }}</td>
                  <td>
                    <span class="st-pill" [class.on]="(v.status || '').toLowerCase() === 'active'">
                      <span class="dot"></span>{{ v.status || '—' }}
                    </span>
                  </td>
                  <td>{{ v.sowExpiry || '—' }}</td>
                  <td>{{ v.doj || '—' }}</td>
                  <td [attr.title]="v.vendor || null">{{ v.vendor || '—' }}</td>
                  <td [attr.title]="v.location || null">{{ v.location || '—' }}</td>
                  <td class="c mono">{{ v.totalExp || '—' }}</td>
                  <td>{{ v.rto || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="op-tfoot">
            <div class="op-info">
              Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ displayData.length }}</b> contractors
            </div>
            <div class="op-pager">
              <button class="pg" (click)="prevPage()" [disabled]="pageIndex === 1" aria-label="Previous page">‹</button>
              <button
                *ngFor="let pnum of pageWindow; trackBy: trackByIndex"
                class="pg"
                [class.on]="pnum === pageIndex"
                [disabled]="pnum === -1"
                (click)="goToPage(pnum)"
              >{{ pnum === -1 ? '…' : pnum }}</button>
              <button class="pg" (click)="nextPage()" [disabled]="pageIndex >= totalPages" aria-label="Next page">›</button>
            </div>
            <div class="op-psize">
              <span>Rows</span>
              <select [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Rows per page">
                <option [value]="10">10</option>
                <option [value]="25">25</option>
                <option [value]="50">50</option>
              </select>
            </div>
          </div>
        </ng-container>
        <ng-template #noDataTemplate>
          <section class="records-container" aria-label="Records section">
            <div class="empty-state">
              <ng-container *ngIf="isDataLoaded && !displayData?.length">
                <h2 class="empty-state-title">
                  {{ ContractorListEnum.NoRecordsTitle }}
                </h2>
                <img
                  [src]="imageSrc"
                  [alt]="'No contractors available'"
                  class="empty-state-image"
                />
              </ng-container>
            </div>
          </section>
        </ng-template>
      </div>
    </div>
  </div>
  <app-modal-wrapper
    *ngIf="showContractorProfile"
    [showModal]="showContractorProfile"
  >
    <app-ops-contractor-profile
      [contractorData]="selectedContractor"
      (close)="showContractorProfile = false"
    ></app-ops-contractor-profile>
  </app-modal-wrapper>
</div>
